module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00315.ba01b941.jpg";